<template>
  <div>
    <div class="ts-relative ts-mt-1">
      <div
        class="ts-absolute ts-inset-y-0 ts-left-0 ts-flex ts-items-center ts-pl-3 ts-pointer-events-none"
      >
        <svg
          class="ts-w-5 ts-h-5 ts-text-gray-500 dark:ts-text-gray-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <div class="ts-flex ts-items-center">
        <input
          v-model="search"
          type="text"
          id="table-search"
          class="ts-border-t ts-border-b ts-border-l ts-text-gray-900 ts-text-sm ts-rounded  ts-outline-none ts-block ts-w-full ts-pl-10 ts-px-2 ts-py-2"
          :placeholder="$t('visitation.typeToSearchShop')"
        />
        <a href="#"
          class="ts-px-6 ts-py-2 ts-bg-blue-700 ts-text-white ts-flex ts-items-center ts-rounded-tr ts-rounded-br"
          style="height: 38px;"
          @click.prevent="$emit('fetchShop')"
        >
          <i class="fas fa-sync fa-spin" v-if="fetching"></i>
          <i class="fas fa-sync" v-else></i>
        </a>
      </div>
    </div>
    <div
      class="ts-h-40 ts-border ts-border-gray-100 700 ts-p-3 ts-overflow-y-scroll"
    >
      <table class="ts-w-full">
        <tr>
          <td
            class="ts-w-3 ts-pr-4 ts-p-1 ts-sticky ts-top-0 ts-z-10 ts-bg-white"
            style="width: 10px"
          >
            <input
              type="checkbox"
              class="ts-cursor-pointer"
              id="shop_check_all"
              :checked="isCheckAll"
              @change="onCheckAll"
            />
          </td>
          <td class="ts-sticky ts-top-0 ts-z-10 ts-bg-white">
            <label
              for="shop_check_all"
              class="ts-mb-0 ts-font-normal ts-cursor-pointer"
              >{{ $t('visitation.checkAll') }}</label
            >
          </td>
        </tr>
        <tr v-for="(c, i) in itemList" :key="i" class="ts-border-b">
          <td class="ts-w-3 ts-pr-4 ts-p-1">
            <input
              type="checkbox"
              :value="c"
              :id="'check_s' + i"
              :checked="isChecked(c)"
              class="ts-cursor-pointer"
              @change="e => onCheck(e, c)"
            />
          </td>
          <td>
            <label
              :for="'check_s' + i"
              class="ts-mb-0 ts-font-normal ts-cursor-pointer"
            >
              {{ c.customer_code + '-' + c.customer_name }}
            </label>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'shopSearch',
  props: ['value'],
  data() {
    return {
      fetching: false,
      search: '',
      items: [],
      model: {},
      customers: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    itemList() {
      return this.customers.filter(
        v =>
          v.customer_code.indexOf(this.search.trim()) >= 0 ||
          v.customer_name.indexOf(this.search.trim()) >= 0
      )
    },
    isCheckAll() {
      if (!this.model.customer_list.length) return false
      return this.model.customer_list.length == this.customers.length
    }
  },
  methods: {
    ...mapActions('customer/visitation', ['getShop']),
    fetchOnCommuneChange({ provinceCode, districtCode, communeCode }) {
      this.fetching = true
      this.$emit('loading', true)
      this.getShop({
        province_code: provinceCode ? provinceCode : [],
        district_code: districtCode ? districtCode : [],
        commune_code: communeCode ? communeCode : []
      })
        .then(response => {
          this.customers = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
          this.fetching = false
        })
    },
    onCheck(e, v) {
      if (!e.target.checked) {
        this.removeFromListAndMap(v)
      } else {
        this.addShopToListAndMap(v)
      }
    },
    findById(v) {
      return this.model.customer_list.find(c => c.customer_id == v.customer_id)
    },
    isChecked(v) {
      return (
        this.model.customer_list.find(c => c.customer_id == v.customer_id) !=
        undefined
      )
    },
    addShopToListAndMap(v) {
      if (this.findById(v) == undefined) {
        this.model.customer_list.push(
          Object.assign(v, {
            duration_in_minute: 30
          })
        )
      }
    },
    removeFromListAndMap(v) {
      this.model.customer_list.splice(
        this.model.customer_list.indexOf(this.findById(v)),
        1
      )
    },
    onCheckAll(e) {
      if (!e.target.checked) {
        this.model.customer_list.forEach(el => {
          this.removeFromListAndMap(el)
        })

        return
      }
      this.itemList.forEach(v => {
        this.addShopToListAndMap(v)
      })
    }
  }
}
</script>
